module.exports = App.Router.map ->
  @resource 'auth', ->
    @route 'login'
    @route 'restore'
    @route 'logout'

  ###
  # CRM
  ###
  @route 'clients', ->
    @route 'client', path: '/:client_id'

  @route 'courier-apps'

  ###
  # Настройки
  ###
  @route 'settings', ->
    # Настройки профиля
    @route 'profile'

    # Настройки аналитики
    @route 'analytics'

    # Интеграции
    @route 'integrations'

    # Настройки интеграций
    @route 'integrations_settings'

    # Настройки способов оплаты заказа
    @route 'payments'

    # Настройки организации
    @route 'organization', ->
      @route 'host'

    # Сотрудники
    @route 'staff', ->
      @route 'show', path: '/:id'
      @route 'create'

    # Бизнес роли
    @route 'business-role', ->
      @route 'show', path: '/:id', ->
        @route 'edit'
      @route 'create'

    # Оплата
    @route 'billing', ->
      @route 'pay', path: '/pay/:sum'
      @route 'tariffs'
      @route 'payment_method'

    # Импорт
    @route 'import'

    # Интерфейс
    @route 'interface'

    # Телефония
    @route 'sip'

    # Яндекс Бизнес
    @route 'yandex_business'


  ###
  # Дэшборд
  ###
  @route 'dashboard'

  ###
  # Роут для UI компонентов
  ###
  @resource 'sandbox'

  ###
  # Список заказов
  ###
  @resource 'orders', ->
    @route 'create'
    @route 'list', ->
      @route 'order', path: '/:order_id'

    @route 'map', ->
      @route 'order', path: '/:order_id', ->
        @route 'detailed'

  ###
  # Акции
  ###
  @route 'promos', ->
    @route 'promo', path: '/:promo_id', ->
      @route 'edit'

    @route 'create'

  ###
  # Рекламные объявления
  ###
  @route 'adverts', ->
    @route 'advert', path: '/:advert_id', ->
      @route 'edit'

    @route 'create'

  ###
  # Баннеры для витрины и мобильного приложения
  ###
  @route 'banners', ->
    @route 'banner', path: '/:banner_id', ->
      @route 'edit', ->
        @route 'story_frame', path: '/story_frame/:story_frame_id'
    @route 'create'
  
  @route 'loyalty-programs', ->
    @route 'loyalty-program', path: '/:loyalty_program_id', ->
      @route 'edit'

    @route 'create'

  @route 'client-tags', ->
    @route 'client-tag', path: '/:client_tag_id', ->
      @route 'edit'

    @route 'create'

  @route 'bonus-categories', ->
    @route 'bonus-category', path: '/:client_tag_id', ->
      @route 'edit'

    @route 'create'

  @route 'static-pages', ->
    @route 'static-page', path: '/:static_page_id', ->
      @route 'edit'

    @route 'create'


  ###
  # Каналы коммуникации
  ###
  @route 'communication-channels', ->
    @route 'communication-channel', path: '/:channel_id', ->
      @route 'edit'
  ###
  # Редактирование доставки
  ###
  @resource 'delivery', ->
    @route 'zones', ->
      @route 'restaurant', path: '/:restaurant_id', ->
        @route 'zone', path: '/:zone_id'
        @route 'create-zone', path: 'create'

    @route 'couriers', ->
      @route 'show', path: '/:courier_id'
      @route 'create'
      @route 'connect'
      @route 'carriers', ->
        @route 'carrier', path: '/:carrier_id'

  ###
  # Редактирование меню
  ###
  @resource 'categories', ->
    @route 'create'
    @resource 'category', path: '/:category_id', ->
      @route 'create-dish'
      @route 'edit'#, path: '/edit'
      @route 'dish', path: '/dishes/:dish_id'

  ###
  # Редактирование конфигуратора
  ###
  @resource 'modifier-groups', ->
    @route 'modifier-group', path: '/:modifier_group_id', ->
      @route 'edit'
    @route 'create'

  ###
  # Редактирование комбо
  ###

  @resource 'dish-groups', ->
    @route 'dish-group', path: '/:dish_group_id', ->
      @route 'edit'
    @route 'create'



  ###
  # Редактирование ресторанов
  ###
  @route 'restaurants', ->
    @route 'create'
    @route 'restaurant', path: '/:restaurant_id'

  ###
  # Выбор тем
  ###
  @resource 'themes'

  ###
  # Настройка мобильного приложения
  ###
  @resource 'mobile-app'

  @route 'cross-login', path: '/cross-login/*token'

  ###
  # Отчеты
  ###
  @resource 'reports'

  ###
  # Роут по-умолчанию, когда никакой другой не подходит
  ###
  @route 'default', path: '*wildcard'
